/**
 * Контент справки для страницы Billing (Рахунки та платежі).
 * Используется в панели справки HelpPanel.
 */
export default {
  // Идентификатор страницы
  pageKey: 'billing',

  // Ключ локализации заголовка страницы
  titleKey: 'help.pages.billing.title',

  // Ключ локализации описания страницы
  overviewKey: 'help.pages.billing.overview',

  // Идентификатор связанного тура
  tourId: 'billing-page',

  // FAQ - часто задаваемые вопросы
  faq: [
    {
      id: 'invoice-statuses',
      questionKey: 'help.pages.billing.faq.invoiceStatuses.question',
      answerKey: 'help.pages.billing.faq.invoiceStatuses.answer',
    },
    {
      id: 'download-invoice',
      questionKey: 'help.pages.billing.faq.downloadInvoice.question',
      answerKey: 'help.pages.billing.faq.downloadInvoice.answer',
    },
    {
      id: 'payment-methods',
      questionKey: 'help.pages.billing.faq.paymentMethods.question',
      answerKey: 'help.pages.billing.faq.paymentMethods.answer',
    },
    {
      id: 'overdue-invoice',
      questionKey: 'help.pages.billing.faq.overdueInvoice.question',
      answerKey: 'help.pages.billing.faq.overdueInvoice.answer',
    },
    {
      id: 'invoice-details',
      questionKey: 'help.pages.billing.faq.invoiceDetails.question',
      answerKey: 'help.pages.billing.faq.invoiceDetails.answer',
    },
  ],

  // Контекстные подсказки для элементов страницы
  tooltips: {
    statusFilter: 'help.tooltips.billing.statusFilter',
    downloadButton: 'help.tooltips.billing.downloadButton',
    totalSum: 'help.tooltips.billing.totalSum',
    pagination: 'help.tooltips.billing.pagination',
  },

  // Связанные туры (для раздела "Другие обзоры")
  relatedTours: ['onboarding', 'subusers-page'],
}
